export default "__VITE_ASSET__2a3f5e0c__"